import React from "react";
import Dialog from "common/mdc/dialog";
import Form, { Error, DisplayField } from "common/mdc/form/index";
import TextField from "common/mdc/textfield/index";
import Button from "common/mdc/button";
import Icon from "common/mdc/icon";
import { connect } from "react-redux";
import { Actions as FarceActions } from "farce";
import "./attachTagDialog.scss";
import { actions } from "@sma/store/tag/tags";
import CreateNewTag from "../../../components/tag/create/createNewTag";
import { actions as deviceActions } from "../../../store/device/devices";
import { actions as searchActions } from '@sma/store/device/search';

class AttachTagDialog extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      searchText: "",
      newTag: undefined,
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handelSearchLoad = this.handelSearchLoad.bind(this);
    this.handleAttachTag = this.handleAttachTag.bind(this);
    this.handleNewTagCreateFromAttach = this.handleNewTagCreateFromAttach.bind(this);
    this.handleDevicesFilter = this.handleDevicesFilter.bind(this);
  }

  handleSearch(e) {
    this.setState(
      {
        searchText: e.target.value,
      },
      () => {
        const { searchText } = this.state;
        if (searchText.length >= 3) {
          this.props.searchTagsByLabel({ search: searchText, page: 1 }, 1, []);
          return;
        }
        if(searchText.length === 0){
          this.props.attachTagSearchCleared();
          return;
        }
      }
    );
  }

  clearSearch() {
    this.setState({
      searchText: "",
    })
  }

  handelSearchLoad() {
    this.props.searchTagsByLabel(
      {
        search: this.state.searchText,
        page: this.props.searchTagPageNumber + 1,
      },
      this.props.searchTagPageNumber + 1,
      this.props.data
    );
  }

  handleAttachTag({ deviceId, tagId }, tagDets) {
    this.props.attachTag({ meters: [deviceId], tags: [tagId] }, tagDets);
  }

  handleNewTagCreateFromAttach(tagObj) {
    if(tagObj.namespace === ""){
      tagObj.namespace = "user";
    }
    this.setState({
      newTag: {...tagObj}
    },()=>{})
  }

  handleDevicesFilter() {
    const {
      selectedTagsList,
      devicesFilterByTag,
      setValue,
      applyCriteria,
      closeAttachDialog,
    } = this.props;

    const tagsListString = selectedTagsList
      .map((tagObj) => {
        return `${tagObj.namespace}:${tagObj.label}`;
      })
      .join(", ");
    devicesFilterByTag(tagsListString);

    const constraintVal = selectedTagsList.reduce((acc, curr, index) => {
      return index === 0 ? `${curr.tagId}` : `${acc} and tagId = ${curr.tagId}`;
    }, "");

    setValue({
      nullable: true,
      property: "tagId",
      type: "plain",
      value: constraintVal,
      constraints:[{operator: "=", value: null}],
    }, 0, constraintVal);

    applyCriteria({
      nullable: true,
      property: "tagId",
      type: "plain",
    });
    closeAttachDialog(false);
  }

  render() {
    const {
      closeAttachDialog,
      deviceId,
      attachTagPending,
      attachTagError,
      showCreateTagDialog,
      createTagDialog,
      newTagCreatedFromAttach,
      newTagId,
      devicesFilter,
      selectedTagsList,
      clearSelectedTagsList,
      addToSelectedTagsList,
      removeFromSelectedTagsList,
      removeCriteria,
      addCriteria,
    } = this.props;
    let {data, total} = this.props;
    if(newTagCreatedFromAttach){
      data = [
        {tagId: newTagId, ...this.state.newTag, isNew: true}, //concatinating newly created tag obj
        ...data.filter((obj)=>{return obj.tagId !== parseInt(newTagId)}) //filtering newly created tag if user is trying to filter after create
      ];
      total = data.length === 1 ? 1 : total; // making total to 1 if there is only newly created tag
    }

    return (
      <Dialog
        title={devicesFilter ? "Search Tag" : "Attach Tag"}
        loading={attachTagPending}
        buttons={[
          <button
            className="mdc-button mdc-dialog__footer__button"
            onClick={() => closeAttachDialog(false)}
          >
            <span>close</span>
          </button>,
          devicesFilter ? null :
          (<button
            className="mdc-button mdc-button--raised mdc-card__action create-new-tag-btn"
            type="button"
            onClick={() => showCreateTagDialog(true, true)}
          >
            <span>Create Tag</span>
          </button>),
          devicesFilter ?
          (<button
            className="mdc-button"
            disabled={selectedTagsList.length === 0}
            type="button"
            onClick={() => {
              clearSelectedTagsList();
              removeCriteria({
                nullable: true,
                property: "tagId",
                type: "plain",
              });
              addCriteria({
                nullable: true,
                property: "tagId",
                type: "plain",
                });
            }}
            style={{ margin: "0 10px" }}
          >
            <span>clear all</span>
          </button>) : null,
          devicesFilter ?
          (<button
            className="mdc-button mdc-button--raised mdc-card__action"
            disabled={selectedTagsList.length === 0}
            type="button"
            onClick={() => this.handleDevicesFilter()}
          >
            <span>apply</span>
          </button>) : null,
        ]}
      >
        <Form>
          {attachTagError && <Error>{attachTagError}</Error>}
          <DisplayField label={"Search"}>
            <TextField
              className="group-name-textfield"
              placeholder={"Search for labels (minimum 3 characters)"}
              type="text"
              style={{ minWidth: "400px" }}
              onChange={(e) => this.handleSearch(e)}
            />
          </DisplayField>
          <DisplayField label={`Results`}>
            <div className="tag-results-container">
              {data ? (
                <div className="tags-list">
                  {data.map((obj) => (
                    <span
                      key={`${obj.tagId}${obj.isNew ? "new-pill" : ""}`}
                      className={`tag-pill result-tag-pill ${
                        obj.isNew ? "new-pill" : ""
                      } ${
                       devicesFilter && selectedTagsList.some((tag) => tag.tagId === obj.tagId)
                          ? "is-tagged"
                          : ""
                      }`}
                      title={`${obj.namespace} -- ${obj.label}`}
                      onClick={() => {
                        devicesFilter
                          ? !selectedTagsList.includes(obj) &&
                            addToSelectedTagsList(obj)
                          : this.handleAttachTag({ deviceId, tagId: obj.tagId }, obj);
                      }}
                    >
                      <span className="n_space"> {obj.namespace} </span>
                      <span className="label"> {obj.label} </span>
                    </span>
                  ))}
                </div>
              ) : null}
              <Button
                className="mdc-button mdc-button--raised load-more-results-btn"
                type="button"
                disabled={
                  total === undefined ||
                  (data !== undefined && data.length === total)
                }
                onClick={() => this.handelSearchLoad()}
                title={`Load more`}
              >
                <Icon>keyboard_double_arrow_down</Icon>
              </Button>
            </div>
            <i className="attach-tag-note">
              {devicesFilter
                ? "Click matching tag to filter."
                : "Click matching tag to attach to meter."}
            </i>
          </DisplayField>
          {devicesFilter ?
          (<DisplayField label={`Selected Tags`} style={{ marginTop: "25px" }}>
            <div className="tag-results-container" style={{ height: "100px" }}>
              {selectedTagsList ? (
                <div className="tags-list">
                  {selectedTagsList.map((obj) => (
                    <span
                      key={`${obj.tagId}${obj.isNew ? "new-pill" : ""}`}
                      className={`tag-pill result-tag-pill ${
                        obj.isNew ? "new-pill" : ""
                      }`}
                      title={`${obj.namespace} -- ${obj.label}`}
                    >
                      <span className="n_space"> {obj.namespace} </span>
                      <span
                        className="label"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        {obj.label}
                        <i
                          class="material-icons button cancel"
                          role="button"
                          aria-disabled="false"
                          style={{
                            position: "relative",
                            left: "0.65rem",
                            fontSize: "1.25rem",
                          }}
                          onClick={() => {
                            removeFromSelectedTagsList(obj);
                          }}
                        >
                          cancel
                        </i>
                      </span>
                    </span>
                  ))}
                </div>
              ) : null}
            </div>
            <i className="attach-tag-note">Selected tags to filter.</i>
          </DisplayField>) : null}
        </Form>
        {createTagDialog ? (
          <CreateNewTag
            isAttachTag={true}
            attachLabel={this.state.searchText}
            handleNewTagCreateFromAttach={this.handleNewTagCreateFromAttach}
            clearSearch={this.clearSearch}
          />
        ) : null}
      </Dialog>
    );
  }
}

AttachTagDialog.defaultProps = {
  deviceId: null,
  devicesFilter: false,
};

export default connect(
  (state) => {
    return {
      data: state.tags.data,
      total: state.tags.total,
      searchTagPageNumber: state.tags.searchTagPageNumber,
      attachTagPending: state.tags.attachTag.pending,
      attachTagError: state.tags.attachTag.error,
      createTagDialog: state.tags.createTag.showDialog,
      newTagCreatedFromAttach: state.tags.attachTag.newTagCreatedFromAttach,
      newTagId: state.tags.attachTag.newTagId,
      selectedTagsList: state.tags.selectedTagsList,
    };
  },
  {
    closeAttachDialog: actions.showAttchTagDialog,
    searchTagsByLabel: actions.searchTagsByLabel,
    attachTag: actions.attachTag,
    showCreateTagDialog: actions.showCreateTagDialog,
    attachTagSearchCleared: actions.attachTagSearchCleared,
    devicesFilterByTag: deviceActions.devicesFilterByTag,
    addCriteria: searchActions.addCriteria,
    setValue: searchActions.setValue,
    applyCriteria: searchActions.applyCriteria,
    addConstraint: searchActions.addConstraint,
    loadDevices: deviceActions.load,
    clearSelectedTagsList: actions.clearSelectedTagsList,
    addToSelectedTagsList: actions.addToSelectedTagsList,
    removeFromSelectedTagsList: actions.removeFromSelectedTagsList,
    removeCriteria: searchActions.removeCriteria,
  }
)(AttachTagDialog);
